import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export const sliderCaseStudiesHeading = () => {
  const element = document.getElementById("js-case-studies-heading");

  if (!element) return;

  const splide = new Splide(element, {
    type: "loop",
    drag: false,
    arrows: false,
    pagination: false,
    perPage: 4,
    gap: 40,
    autoWidth: true,
    focus: "center",
    speed: 1000,
    easing: "linear",
    autoScroll: {
      speed: 0.5,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
  });

  splide.mount({ AutoScroll });
};
